import type { InterventionJobModulesTriggersProps } from "./intervention-job-modules-triggers.type";

import { useGetInterventionTemplate } from "@/entities/intervention-template";
import { JOB_MODULE_SUBJECT_TYPES } from "@/entities/job-module";
import JobModuleTriggerCards from "@/modules/job-module/job-module-trigger-cards";

const InterventionJobModulesTriggers = ({
  intervention,
}: InterventionJobModulesTriggersProps) => {
  const { template, isLoading } = useGetInterventionTemplate(
    intervention.intervention_template_id
  );

  return (
    <JobModuleTriggerCards
      modules={template?.modules ?? []}
      subjectType={JOB_MODULE_SUBJECT_TYPES.INTERVENTION}
      subjectIds={[intervention.id]}
      loading={isLoading}
    />
  );
};

export default InterventionJobModulesTriggers;
